import { render } from "./QuestionNine.vue?vue&type=template&id=4d45c39b"
import script from "./QuestionNine.vue?vue&type=script&lang=js"
export * from "./QuestionNine.vue?vue&type=script&lang=js"

import "./QuestionNine.vue?vue&type=style&index=0&id=4d45c39b&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__